/* eslint no-undef: 0 */

import { domReady } from "@roots/sage/client";

import aosInit from "./components/aos-init";
import menu from "./components/menu";
import formLabels from "./components/form-labels";
import slider from "./components/slider";
import loginFunctionality from "./components/login-functionality";
import accordion from "./components/accordion";
import testimonials from "./components/testimonials";
import donationForm from "./components/donation-form";
import latestNewsSlider from "./components/latest-news-slider";
import reportsFiltering from "./components/reports-filtering";
import postFiltering from "./components/post-filtering";
import caseStudiesFiltering from "./components/case-studies-filtering";
import smoothScroll from "./components/smooth-scroll";

/**
 * app.main
 */
const main = async (err) => {
    if (err) {
        // handle hmr errors
        console.error(err);
    }

    aosInit();
    formLabels();
    menu();
    slider();
    loginFunctionality();
    accordion();
    testimonials();
    donationForm();
    latestNewsSlider();
    reportsFiltering();
    postFiltering();
    caseStudiesFiltering();
    smoothScroll();
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main);
